(function () {
  function initSalesSection(root) {
    if (!root || root.dataset.vsReady === 'true') return;

    root.dataset.vsReady = 'true';

    var routeRoot = root.dataset.rootUrl || '/';
    var buySuffix = root.dataset.buySuffix || 'in den Warenkorb';
    var mobileBuyLabel = root.dataset.mobileBuyLabel || 'In den Warenkorb';
    var unavailableLabel = root.dataset.unavailableLabel || 'Derzeit nicht verfügbar';
    var b2bUnitSingular = root.dataset.b2bUnitSingular || 'Dose';
    var b2bUnitPlural = root.dataset.b2bUnitPlural || 'Dosen';
    var planButtons = Array.prototype.slice.call(root.querySelectorAll('[data-vs-variant]'));
    var buyButtons = Array.prototype.slice.call(
      root.querySelectorAll('[data-vs-buy], [data-vs-mobile-buy]')
    );
    var shippingBoxes = Array.prototype.slice.call(root.querySelectorAll('[data-vs-shipping]'));
    var quantityBoxes = Array.prototype.slice.call(root.querySelectorAll('[data-vs-b2b-quantity]'));
    var quantityInputs = Array.prototype.slice.call(root.querySelectorAll('[data-vs-b2b-qty]'));
    var unitPriceNodes = Array.prototype.slice.call(root.querySelectorAll('[data-vs-b2b-unit-price]'));
    var mobileBar = root.querySelector('[data-vs-mobile-bar]');
    var mobilePlanLabel = root.querySelector('[data-vs-mobile-label]');
    var mobilePrice = root.querySelector('[data-vs-mobile-price]');
    var topBuybox = root.querySelector('.vs-sales-buybox--hero');
    var finalBuybox = root.querySelector('#vs-purchase-bottom');
    var selectedButton = null;

    if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/';

    function findAvailableButton() {
      return planButtons.find(function (button) {
        return !button.disabled && button.getAttribute('aria-disabled') !== 'true';
      });
    }

    function findButton(variantId) {
      return planButtons.find(function (button) {
        return button.dataset.vsVariant === String(variantId) && !button.disabled;
      });
    }

    function getPlanLabel(variantId) {
      var matchingButton = findButton(variantId);
      return matchingButton ? matchingButton.dataset.vsPlanLabel : '';
    }

    function getQuantityRules(button) {
      var source = button || selectedButton;
      if (!source) return { min: 1, increment: 1, max: null };

      var min = Number(source.dataset.vsQuantityMin || 1);
      var increment = Number(source.dataset.vsQuantityIncrement || 1);
      var max = source.dataset.vsQuantityMax ? Number(source.dataset.vsQuantityMax) : null;

      if (!Number.isFinite(min) || min < 1) min = 1;
      if (!Number.isFinite(increment) || increment < 1) increment = 1;
      if (max !== null && (!Number.isFinite(max) || max < min)) max = null;

      return { min: min, increment: increment, max: max };
    }

    function normalizeQuantity(value) {
      var rules = getQuantityRules();
      var quantity = Number.parseInt(value, 10);

      if (!Number.isFinite(quantity)) quantity = rules.min;
      quantity = Math.max(quantity, rules.min);

      if (rules.increment > 1 && quantity % rules.increment !== 0) {
        quantity = Math.ceil(quantity / rules.increment) * rules.increment;
      }

      if (rules.max !== null) quantity = Math.min(quantity, rules.max);
      return quantity;
    }

    function getQuantity() {
      if (!quantityInputs.length) return 1;
      return normalizeQuantity(quantityInputs[0].value);
    }

    function syncQuantityInputs(quantity) {
      var rules = getQuantityRules();

      quantityInputs.forEach(function (input) {
        input.value = String(quantity);
        input.min = String(rules.min);
        input.step = String(rules.increment);

        if (rules.max !== null) input.max = String(rules.max);
        else input.removeAttribute('max');
      });

      quantityBoxes.forEach(function (box) {
        var minus = box.querySelector('[data-vs-qty-minus]');
        var plus = box.querySelector('[data-vs-qty-plus]');

        if (minus) minus.disabled = quantity <= rules.min;
        if (plus) plus.disabled = rules.max !== null && quantity >= rules.max;
      });
    }

    function parsePriceBreaks(button) {
      var raw = button && button.dataset.vsPriceBreaks ? button.dataset.vsPriceBreaks : '';
      if (!raw) return [];

      return raw.split('||').map(function (entry) {
        var parts = entry.split('::');
        return {
          minimum: Number(parts[0]),
          price: parts.slice(1).join('::')
        };
      }).filter(function (priceBreak) {
        return Number.isFinite(priceBreak.minimum) && priceBreak.price;
      }).sort(function (a, b) {
        return a.minimum - b.minimum;
      });
    }

    function getUnitPrice(button, quantity) {
      if (!button) return '';

      var price = button.dataset.vsPrice || '';
      parsePriceBreaks(button).forEach(function (priceBreak) {
        if (quantity >= priceBreak.minimum) price = priceBreak.price;
      });

      return price;
    }

    function updateUnitPrice(quantity) {
      if (!unitPriceNodes.length || !selectedButton) return;

      var unitPrice = getUnitPrice(selectedButton, quantity);
      unitPriceNodes.forEach(function (node) {
        node.textContent = unitPrice;
      });

      if (mobilePrice && quantityInputs.length) {
        mobilePrice.textContent = unitPrice;
      }
    }

    function updateShipping(packCount, quantity) {
      var totalPackCount = Number(packCount || 1) * Number(quantity || 1);

      shippingBoxes.forEach(function (shippingBox) {
        var freeFrom = Number(shippingBox.dataset.freeFrom || 0);
        var isFree = freeFrom > 0 && totalPackCount >= freeFrom;
        var freeLabels = Array.prototype.slice.call(
          shippingBox.querySelectorAll('[data-vs-shipping-free]')
        );

        shippingBox.classList.toggle('is-free', isFree);

        freeLabels.forEach(function (label) {
          label.hidden = !isFree;
        });
      });
    }

    function updatePurchaseLinks() {
      if (!selectedButton) return;

      var selectedId = selectedButton.dataset.vsVariant;
      var planLabel = getPlanLabel(selectedId);
      var quantity = getQuantity();
      var hasB2BQuantity = quantityInputs.length > 0;
      var quantityLabel = quantity + ' ' + (quantity === 1 ? b2bUnitSingular : b2bUnitPlural);

      buyButtons.forEach(function (button) {
        button.href = routeRoot + 'cart/' + selectedId + ':' + quantity;

        if (button.hasAttribute('data-vs-mobile-buy')) {
          button.textContent = mobileBuyLabel;
        } else if (hasB2BQuantity) {
          button.textContent = (quantityLabel + ' ' + buySuffix).trim();
        } else {
          button.textContent = (planLabel + ' ' + buySuffix).trim();
        }

        button.classList.remove('is-disabled');
        button.removeAttribute('aria-disabled');
      });

      updateUnitPrice(quantity);
      updateShipping(selectedButton.dataset.vsPackCount || '1', quantity);
    }

    function setQuantity(value) {
      var quantity = normalizeQuantity(value);
      syncQuantityInputs(quantity);
      updatePurchaseLinks();
    }

    function selectVariant(variantId) {
      var selectedId = String(variantId);
      selectedButton = findButton(selectedId) || findAvailableButton();

      if (!selectedButton) {
        buyButtons.forEach(function (button) {
          button.removeAttribute('href');
          button.textContent = unavailableLabel;
          button.classList.add('is-disabled');
          button.setAttribute('aria-disabled', 'true');
        });
        return;
      }

      selectedId = selectedButton.dataset.vsVariant;

      planButtons.forEach(function (button) {
        var isSelected = button.dataset.vsVariant === selectedId;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      if (mobilePlanLabel) mobilePlanLabel.textContent = getPlanLabel(selectedId);
      if (mobilePrice && !quantityInputs.length) {
        mobilePrice.textContent = selectedButton.dataset.vsPrice || '';
      }

      setQuantity(getQuantity());
    }

    planButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!button.disabled) selectVariant(button.dataset.vsVariant);
      });
    });

    quantityBoxes.forEach(function (box) {
      var input = box.querySelector('[data-vs-b2b-qty]');
      var minus = box.querySelector('[data-vs-qty-minus]');
      var plus = box.querySelector('[data-vs-qty-plus]');

      if (!input) return;

      if (minus) {
        minus.addEventListener('click', function () {
          var rules = getQuantityRules();
          setQuantity(getQuantity() - rules.increment);
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          var rules = getQuantityRules();
          setQuantity(getQuantity() + rules.increment);
        });
      }

      input.addEventListener('input', function () {
        var typed = Number.parseInt(input.value, 10);
        if (Number.isFinite(typed)) {
          quantityInputs.forEach(function (otherInput) {
            if (otherInput !== input) otherInput.value = String(typed);
          });
        }
      });

      input.addEventListener('change', function () {
        setQuantity(input.value);
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          setQuantity(input.value);
        }
      });
    });

    var initiallySelected = planButtons.find(function (button) {
      return button.classList.contains('is-selected') && !button.disabled;
    });

    selectVariant(initiallySelected ? initiallySelected.dataset.vsVariant : '');

    if (mobileBar && topBuybox) {
      var updateQueued = false;

      function updateMobileBar() {
        updateQueued = false;

        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var topBounds = topBuybox.getBoundingClientRect();
        var finalBounds = finalBuybox ? finalBuybox.getBoundingClientRect() : null;
        var topHasPassed = topBounds.bottom <= 0;
        var finalIsVisible = finalBounds
          ? finalBounds.top < window.innerHeight && finalBounds.bottom > 0
          : false;
        var shouldShow = isMobile && topHasPassed && !finalIsVisible;

        mobileBar.hidden = !shouldShow;
        mobileBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      function queueMobileBarUpdate() {
        if (updateQueued) return;
        updateQueued = true;
        window.requestAnimationFrame(updateMobileBar);
      }

      window.addEventListener('scroll', queueMobileBarUpdate, { passive: true });
      window.addEventListener('resize', queueMobileBarUpdate);
      updateMobileBar();
    }
  }

  function initAllSalesSections(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-vs-sales]')) initSalesSection(context);
    context.querySelectorAll('[data-vs-sales]').forEach(initSalesSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSalesSections(document);
    });
  } else {
    initAllSalesSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllSalesSections(event.target);
  });
})();
